import { useEffect } from "react";
import { OrderDetailsViewModel } from "../../viewmodels/orders/OrderDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import CreateNewOrderForm from "../../components/forms/orders/CreateNewOrderForm";
import { ManualLaboursAssignedViewModel } from "../../viewmodels/setup/manualLabours/ManualLaboursAssignedViewModel";
import EmptyModal from "../../components/modals/EmptyModal";
import TableLoadingSkeleton from "../../components/shared/TableLoadingSkeleton";
import SlideOver from "../../components/slideOver/SlideOver";
import { useParams } from "react-router-dom";
import AuditActionLink from "../../components/audit/AuditActionLink";
function OrderDetails(props) {
  const { addSnackbar, logout } = props;

  const { orderId } = useParams();

  const {
    carriers,
    getCarriersForDropdown,
    customers,
    getCustomersForDropdown,
    getManufacturedProductsForDropdown,
    loading,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateOrderApiCall,
    productsOptions,
    getOrderDetails,
    order,
    onUpdateOrderItem,
    onCreatePriceSplit,
    onUpdatePriceSplit,
    onDeletePriceSplit,
    printOrderInvoice,
    printShippingSummary,
    printShippingDetails,
    rowDetails,
    fetchRowDetails,
    loadingRows,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    selectedItems,
    setSelectedItems,
    currencyOptions,
    getCurrenciesForDropdown,
  } = OrderDetailsViewModel(logout, orderId, addSnackbar);

  const {
    getManualLaboursAssignedByOrderId,
    manualLaboursAssigned,
    getManualLaboursForDropdown,
    loading: manualLaboursLoading,
    openAddManualLabourAssignedModal,
    updateManualLabourAssigned,
    askDeleteManualLabourAssigned,
    setEmptyModelOpen: setManualLabourEmptyModalOpen, // renamed to avoid conflict
    emptyModal: manualLabourEmptyModal, // renamed to avoid conflict
    getEmployeeOptionsForDropdown,
    employeeOptions,
  } = ManualLaboursAssignedViewModel(logout, orderId, addSnackbar);

  useEffect(() => {
    getCurrenciesForDropdown();
    getEmployeeOptionsForDropdown();
    getManufacturedProductsForDropdown();
    getCustomersForDropdown();
    getCarriersForDropdown();
    getManualLaboursForDropdown();
    getManualLaboursAssignedByOrderId();
    getOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto flex items-center">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              PO: {order.po_number}
            </h1>
            {orderId ? (
              <AuditActionLink
                slug="order"
                id={orderId}
                name={order.po_number}
              />
            ) : null}
          </div>
          {loading ? (
            <TableLoadingSkeleton rows={5} columns={4} />
          ) : (
            <div className="mt-5">
              <CreateNewOrderForm
                carriers={carriers}
                customers={customers}
                productsOptions={productsOptions}
                isEdit={true}
                loading={loading}
                setEmptyModelOpen={setEmptyModelOpen}
                showErrorModal={showErrorModal}
                updateOrderApiCall={updateOrderApiCall}
                setSlideOver={setSlideOver}
                order={order}
                onUpdateOrderItem={onUpdateOrderItem}
                onCreatePriceSplit={onCreatePriceSplit}
                onUpdatePriceSplit={onUpdatePriceSplit}
                onDeletePriceSplit={onDeletePriceSplit}
                printOrderInvoice={printOrderInvoice}
                printShippingSummary={printShippingSummary}
                printShippingDetails={printShippingDetails}
                closed={order.status === 6}
                rowDetails={rowDetails}
                fetchRowDetails={fetchRowDetails}
                loadingRows={loadingRows}
                fetchSubRowDetails={fetchSubRowDetails}
                subRowDetails={subRowDetails}
                subLoadingRows={subLoadingRows}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                currencyOptions={currencyOptions}
                manualLaboursAssigned={manualLaboursAssigned}
                manualLaboursLoading={manualLaboursLoading}
                onAddManualLabour={() =>
                  openAddManualLabourAssignedModal(false, null, null)
                }
                onUpdateManualLabour={updateManualLabourAssigned}
                onDeleteManualLabour={askDeleteManualLabourAssigned}
              />
            </div>
          )}
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <EmptyModal
        childComponent={manualLabourEmptyModal.childComponent}
        open={manualLabourEmptyModal.open}
        setOpen={setManualLabourEmptyModalOpen}
        size="sm:max-w-2xl"
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetails),
);
